/* Keep the custom selector in sync with Shopify's actual selling plan allocations. */
(() => {
  if (window.totySubscriptionPricingSync) return;
  window.totySubscriptionPricingSync = true;

  function update(picker) {
    const form = picker.closest('form');
    const data = picker.querySelector('[data-subscription-pricing]');
    if (!form || !data) return;
    const variants = JSON.parse(data.textContent).variants;
    const selectedOptions = Array.from(form.querySelectorAll('[data-variant-picker] input[data-option]:checked'));
    const variantID = form.querySelector('input[name="id"]')?.value;
    const variant = (selectedOptions.length ? variants.find(candidate => selectedOptions.every(option => candidate.options.includes(option.value))) : null)
      || variants.find(candidate => String(candidate.id) === String(variantID));
    if (!variant) return;

    const oneTime = picker.querySelector('input[name="selling_plan"][value=""]');
    const planInputs = Array.from(picker.querySelectorAll('input[name="selling_plan"]')).filter(input => input.value);
    planInputs.forEach(input => {
      const allocation = variant.allocations.find(candidate => String(candidate.id) === input.value);
      input.disabled = !allocation;
      if (allocation) input.setAttribute('data-price-update', allocation.price);
      else input.removeAttribute('data-price-update');
    });
    let selectedPlan = planInputs.find(input => input.checked);
    if (selectedPlan?.disabled && oneTime) {
      oneTime.checked = true;
      selectedPlan = null;
    }
    const displayPlan = selectedPlan || planInputs.find(input => !input.disabled);
    const allocation = variant.allocations.find(candidate => String(candidate.id) === displayPlan?.value);
    if (oneTime) oneTime.setAttribute('data-original-price', variant.originalPrice);
    picker.querySelectorAll('[data-subscription-original-price]').forEach(element => {
      if (!element.hasAttribute('data-custom-pack-price')) element.textContent = variant.originalPrice;
    });
    const label = picker.querySelector('[data-subscription-label]');
    if (label && displayPlan) label.htmlFor = displayPlan.id;
    if (allocation) {
      picker.querySelector('[data-subscription-price]').textContent = allocation.price;
      const discount = picker.querySelector('[data-subscription-discount]');
      discount.textContent = `${allocation.percentage}%`;
      discount.hidden = allocation.percentage === 0;
      picker.querySelectorAll('[data-subscription-savings]').forEach(element => {
        element.textContent = allocation.savings;
      });
      picker.querySelectorAll('[data-selected-selling-plan-name]').forEach(element => {
        element.textContent = displayPlan.getAttribute('data-selling-plan-name');
      });
    }
    const price = selectedPlan && allocation ? allocation.price : variant.originalPrice;
    form.querySelectorAll('[data-skio-price]').forEach(element => { element.textContent = price; });
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-subscription-pricing-sync]').forEach(update);
  }

  // Capture updates attributes before the existing ProductForm change listeners use them.
  document.addEventListener('change', event => {
    const form = event.target.closest('form');
    const picker = form?.querySelector('[data-subscription-pricing-sync]');
    if (!picker) return;
    update(picker);
    // The existing form code can update variant IDs and pack selection in the same event.
    queueMicrotask(() => update(picker));
  }, true);
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('global components loaded', () => initialize());
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState !== 'loading') initialize();
})();
